import React from 'react';
import { useLocation } from 'react-router-dom';
import { BookingWizard } from '../components/booking/BookingWizard';
type LocationState = {
  serviceId?: string;
} | null;
export function Book() {
  const location = useLocation();
  const state = location.state as LocationState;
  return <BookingWizard initialServiceId={state?.serviceId ?? null} data-id="element-1047" data-mp="1s1vpld9ilnay" />;
}